export default __webpack_public_path__ + "static/media/notebook-template.333954d2.svg";